module.exports = __webpack_public_path__ + "img/de.36616830.svg";